import axios from "./_axios";
import { API } from "./apiEndPoints";

/** Secure app configuration (includes LaunchDarkly client-side ID). */
export const getAppConfig = async () => {
  const result = await axios()({
    method: "get",
    url: API.APP_CONFIG,
  });
  return result;
};
